import React, {useEffect, useState} from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import {Asset} from "../../../../plugins/gatsby-plugin-atollon";
import marqueeEffect from "../../../hooks/marquee-effect";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
// TEST: placeholder badge images for the woods/5-icon layout test
import TestBadge from "../../../assets/images/95-years.jpg";

gsap.registerPlugin(ScrollTrigger)

const MARQUEE_THRESHOLD = 8;


const AwardsCta = ({title, awards, image, video, special, theme}) => {
    // TEST: override with mock data — remove when done previewing

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const mq = window.matchMedia('(max-width: 899px)');
        const update = () => setIsMobile(mq.matches);
        update();
        mq.addEventListener('change', update);
        return () => mq.removeEventListener('change', update);
    }, []);

    const isMarquee = isMobile || (awards?.length || 0) >= MARQUEE_THRESHOLD;

    useEffect(() => {
        if (isMarquee) {
            marqueeEffect(gsap.utils.toArray(".awards-cta__marquees-wrapper"), {paused: false, repeat: -1,});
        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: `.awards-cta__inner`,
                start: 'bottom bottom',
                end: 'bottom top',
                scrub: true,
            },
        });


        tl.fromTo(
            `.awards-cta__inner .awards-cta__wrapper`,
            { yPercent: 0 },
            { yPercent: 35, ease: 'none' }
        );

        return () => {
            tl.kill()
        }
    }, [isMarquee]);

    return (
        <section className={`awards-cta ${theme?.toLowerCase() || ''}${special ? ' special' : ''}${!image && !video ? ' special-no-image' : ''}${!isMarquee ? ' awards-cta--static' : ''}`}>
            <div className='awards-cta__inner'>
                <div className='awards-cta__wrapper'>
                    { (image || video) &&
                    <div className='awards-cta__media'>
                        {image && !video && <Asset asset={image}/>}
                        {video && <video src={video} autoPlay loop muted playsInline/>}
                    </div>
                    }
                    <div className='awards-cta__info'>
                        {title && <h2 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h2>}
                        { awards?.length > 0 && isMarquee &&
                            <div className='awards-cta__marquees'>
                                {[0, 1, 2].map((row) => (
                                    <div key={row} className='awards-cta__marquees-wrapper'>
                                        {awards.map((el, i) => (
                                            <div key={i} className='awards-cta__item'>
                                                <Asset asset={el}/>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        }
                        { awards?.length > 0 && !isMarquee &&
                            <div className='awards-cta__items'>
                                {awards.map((el, i) => (
                                    <div key={i} className='awards-cta__item'>
                                        <Asset asset={el}/>
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AwardsCta

export const query = graphql`
fragment AwardsCtaProps on DatoCmsAwardsCta {
  ... on DatoCmsAwardsCta {
    id
    video
    title
    image {
      ...InternalAssetProps
    }
    awards {
      ...InternalAssetProps
    }
    special
  }
}
`;